import {
	Button,
	Dropdown,
	Grid,
	Header,
	Modal,
	Radio
} from "semantic-ui-react";
import Checkpoint from "models/checkpoint";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

const ModalExportPDF = ({ checkpoint, downloadExport, onClose, ...rest }) => {
	const { t } = useTranslation();
	const [ordering, setOrdering] = React.useState("last_name");
	const [hasCompany, setHasCompany] = React.useState(false);

	return (
		<Modal className="manualexport" {...rest}>
			<Header
				content={t(
					[
						"access.exploitation.editManualControl.exportSettings",
						`Export settings of ${checkpoint.name()} to PDF`
					],
					{ list: checkpoint.name() }
				)}
			/>
			<Modal.Content>
				<Grid columns={2} stretched stackable>
					<Grid.Column>
						<div className="manualexport-ordering">
							<div className="manualexport-orderingblock">
								<h3>
									{t(
										"access.exploitation.editManualControl.sortingTitle"
									)}
								</h3>
								<p>
									{t(
										"access.exploitation.editManualControl.sortingSubtitle"
									)}
								</p>
								<div>
									<Dropdown
										onChange={(_, { value }) =>
											setOrdering(value)
										}
										value={ordering}
										options={[
											{
												key: "last_name",
												text: t(
													"access.exploitation.editManualControl.lastName"
												),
												value: "last_name"
											},
											{
												key: "first_name",
												text: t(
													"access.exploitation.editManualControl.firstName"
												),
												value: "first_name"
											},
											{
												key: "rate_name",
												text: t(
													"access.exploitation.editManualControl.rateName"
												),
												value: "rate_name"
											},
											{
												key: "id_ticket",
												text: t(
													"access.exploitation.editManualControl.ticketNumber"
												),
												value: "id_ticket"
											}
										]}
										selection
									/>
								</div>
							</div>
						</div>
					</Grid.Column>
					<Grid.Column>
						<div className="manualexport-orderingblock">
							<h3>
								{t(
									"access.exploitation.editManualControl.societyTitle"
								)}
							</h3>
							<p>
								{t(
									"access.exploitation.editManualControl.societySubtitle"
								)}
							</p>
							<div>
								<Radio
									onChange={(_, { checked }) =>
										setHasCompany(checked)
									}
									checked={hasCompany}
									slider
								/>
							</div>
						</div>
					</Grid.Column>
				</Grid>
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={onClose}>{t("access.common.cancel")}</Button>
				<Button
					primary
					onClick={() => downloadExport(ordering, hasCompany)}
				>
					{t("access.common.download")}
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

ModalExportPDF.propTypes = {
	checkpoint: PropTypes.instanceOf(Checkpoint).isRequired,
	downloadExport: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired
};

export default ModalExportPDF;
